/*
 *   File : text-button.js
 *   Author : https://evoqins.com
 *   Description : Custom text button component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react';

//Custom components
import { Icon } from '../Icon';

// Styles
import Colors from "../../Styles/color.scss";

const TextButton = (props) => {

    return (
        props.type == 2 ?
            <div className={`${props.className} d-flex gap-2 align-items-center cursor-pointer w-max-content`}
                onClick={props.onPress}>
                {
                    props.icon &&
                    <Icon icon="arrow-left-blue"
                        wrapperClass="line-height-8px"
                        className="w-28px w-20px-res "
                        color={props.icon_color ? props.icon_color : ""} />
                }
                <span className={`e-font-14-res ${props.labelClass} e-text-primary-color e-primary-font-clash-display e-font-weight-500 e-font-20 line-height-24px ${props.textClassName}`}>
                    {props.name}
                </span>
            </div>
            :
            props.type == 3 ?
                <div className={`${props.className} d-flex gap-2 align-items-center cursor-pointer e-right-arrow-btn-hover `}
                    onClick={props.onPress}>
                    <span className={`e-font-14-res ${props.labelClass} e-text-primary-color e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px`}>
                        {props.name}
                    </span>
                    {
                        props.icon &&
                        <Icon icon="right-arrow"
                            color={Colors.ocean_blue}
                            className={`${props.iconClassName} d-flex padding-2px-top transition w-18px `} />
                    }
                </div>

                :
                <div className={`${props.className} d-flex gap-2 align-items-center cursor-pointer w-max-content`}
                    onClick={props.onPress}>
                    {props.icon === true &&
                        <Icon icon="plus-icon"
                            className="d-flex w-12px"
                            color={Colors.ocean_blue} />
                    }
                    <span className={`e-font-14-res ${props.labelClass} ${props.fontSize ? props.fontSize : "e-font-14"} ${props.fontWeight ? props.fontWeight : "e-font-weight-600"} e-text-primary-color e-alt-font-lato  line-height-20px`}>
                        {props.name}
                    </span>
                </div>

    )
}

export default TextButton;
